import { orderBy } from "lodash";

export const WORK_TEAM_STATUS = {
  ACTIVE: { label: "Activo", color: "success" },
  INACTIVE: { label: "Inactivo", color: "secondary" },
  UNSAVED: { label: "Sin guardar", color: "info" },
  PENDING: { label: "Pendiente", color: "warning" },
  APPROVED: { label: "Aprobado", color: "primary" },
  REJECTED: { label: "Rechazado", color: "danger" },
};

// ACTIVATED se excluye: la solicitud ya es un usuario del consultorio.
export const BRANCH_PREREGISTRATION_STATUSES = ["PENDING", "APPROVED", "REJECTED"];

const normalizeIdentification = (value) =>
  `${value || ""}`.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();

const joinNames = (...parts) =>
  parts
    .map((part) => `${part || ""}`.trim())
    .filter(Boolean)
    .join(" ");

const getTimestamp = (value) => new Date(value || 0).getTime() || 0;

export const getWorkTeamStatus = (row = {}) => {
  if (row.preregistrationStatus) {
    return WORK_TEAM_STATUS[row.preregistrationStatus] || WORK_TEAM_STATUS.PENDING;
  }
  if (row.isPendingSave) return WORK_TEAM_STATUS.UNSAVED;
  return row.medicalStaffProviderEnabled
    ? WORK_TEAM_STATUS.ACTIVE
    : WORK_TEAM_STATUS.INACTIVE;
};

export const buildWorkTeamRows = (users = [], preregistrations = []) => {
  const seenIdentifications = new Set(
    (users || [])
      .map((user) => normalizeIdentification(user?.identification))
      .filter(Boolean),
  );

  const requestRows = orderBy(
    preregistrations || [],
    [(item) => getTimestamp(item?.updatedAt)],
    ["desc"],
  ).reduce((rows, item) => {
    const status = `${item?.statusCode || item?.status || ""}`.toUpperCase();
    const identification = normalizeIdentification(item?.identificationCard);

    if (
      !BRANCH_PREREGISTRATION_STATUSES.includes(status) ||
      !identification ||
      seenIdentifications.has(identification)
    ) {
      return rows;
    }

    seenIdentifications.add(identification);
    return [
      ...rows,
      {
        preregistrationId: item.id,
        preregistrationStatus: status,
        rejectionReason: item.rejectionReason,
        firstName: joinNames(item.firstName, item.middleName),
        lastName: joinNames(item.lastName, item.lastName2),
        identification: item.identificationCard,
        documentType: item.documentType,
        profileId: item.requestedProfileId,
      },
    ];
  }, []);

  return [...(users || []), ...requestRows];
};
